import React, { useCallback, useEffect, useState } from 'react'
import { SimpleTabs } from '@/components/lib'
import api from '../../../api'
import utils from '../../../utils/utils'
import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'
import Availability from './Availability'
import InformedConsentForm from './InformedConsentForm'
import SignedConsents from './SignedConsents'

export default function Consent () {
  const [activeConsentDocument, setActiveConsentDocument] = useState()
  const [consentDocuments, setConsentDocuments] = useState([])
  const { user, trial } = useStore()
  useTitle('Consent', trial)
  const trialId = trial?._id

  const selectConsentDocument = useCallback((doc) => {
    setActiveConsentDocument(doc)
  }, [])

  const reloadConsentDocuments = useCallback((preferredDocId) => {
    if (!trialId || !utils.canReadTrial(user, trial)) return
    api.trials.getConsentDocuments(trialId, data => {
      const docs = data?.documents || []
      setConsentDocuments(docs)
      if (!docs.length) {
        setActiveConsentDocument(undefined)
        return
      }
      const preferred = preferredDocId ? docs.find(d => d._id === preferredDocId) : null
      setActiveConsentDocument(preferred || docs[0])
    })
  }, [trialId, user, trial])

  useEffect(() => {
    reloadConsentDocuments()
  }, [reloadConsentDocuments])

  return (
    <SimpleTabs
      tabs={[
        {
          title: 'Availability',
          to: `/trials/${trial?._id}/consent/availability`,
          content: <Availability trial={trial} activeConsentDocument={activeConsentDocument} />
        },
        utils.canReadTrial(user, trial) && {
          title: 'Informed consent forms',
          to: `/trials/${trial?._id}/consent/form`,
          content: (
            <InformedConsentForm
              trial={trial}
              activeConsentDocument={activeConsentDocument}
              consentDocuments={consentDocuments}
              selectConsentDocument={selectConsentDocument}
              reloadConsentDocuments={reloadConsentDocuments}
            />
          )
        },
        utils.canReadTrialConsents(user, trial) && {
          title: 'Signed consents',
          to: `/trials/${trial?._id}/consent/consents`,
          content: <SignedConsents trial={trial} activeConsentDocument={activeConsentDocument} />
        }
      ]}
    />
  )
}
